// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2cbde332","239":"d12055f3","732":"04da665e"}[chunkId] + ".chunk.js";
};